import { graphql } from "gatsby"
import React from "react"
import { SliderComparisonBlockFieldsFragment } from "../../../graphql-types"
import { ReactCompareSlider } from "react-compare-slider"
import * as styles from "./image-comparison-slider.module.scss"

type RenderProps = {
  data: SliderComparisonBlockFieldsFragment
}

const ImageComparisonSlider: React.FC<RenderProps> = ({ data }) => {
  return (
    <div className={styles.container}>
      <ReactCompareSlider
        itemOne={<img src={data.leftImage.url} alt={data.leftImage.alt || ""} className={styles.image} />}
        itemTwo={<img src={data.rightImage.url} alt={data.rightImage.alt || ""} className={styles.image} />}
        boundsPadding={0}
        position={50}
        style={{
          width: "100%",
          height: "100%",
          maxWidth: "100%",
          maxHeight: "100%",
        }}
      />
      {data.leftText && <div className={`${styles.textOverlay} ${styles.leftText}`}>{data.leftText}</div>}
      {data.rightText && <div className={`${styles.textOverlay} ${styles.rightText}`}>{data.rightText}</div>}
    </div>
  )
}

export const fragments = graphql`
  fragment SliderComparisonBlockFields on DatoCmsSliderComparisonBlock {
    __typename
    leftImage {
      alt
      format
      url
    }
    rightImage {
      alt
      format
      url
    }
    leftText
    rightText
  }
`
export default ImageComparisonSlider
